export default __webpack_public_path__ + "static/media/0151.fc6cddc1.jpg";